/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetNetworkUrlstatusRequest = { url: string };

export const GetNetworkUrlstatusRequest$zodSchema: z.ZodType<
  GetNetworkUrlstatusRequest
> = z.object({
  url: z.string().describe("你需要检查其可访问性状态的完整URL。"),
});

export type GetNetworkUrlstatusBadGatewayDetails = {};

export const GetNetworkUrlstatusBadGatewayDetails$zodSchema: z.ZodType<
  GetNetworkUrlstatusBadGatewayDetails
> = z.object({});

/**
 * 请求URL失败（例如，DNS解析失败、连接超时）
 */
export type GetNetworkUrlstatusBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetNetworkUrlstatusBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkUrlstatusBadGatewayResponseBody$zodSchema: z.ZodType<
  GetNetworkUrlstatusBadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkUrlstatusBadGatewayDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("请求URL失败（例如，DNS解析失败、连接超时）");

export type GetNetworkUrlstatusBadRequestDetails = {};

export const GetNetworkUrlstatusBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkUrlstatusBadRequestDetails
> = z.object({});

/**
 * 请求参数无效。请检查 `url` 参数是否提供且格式正确。
 */
export type GetNetworkUrlstatusBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkUrlstatusBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkUrlstatusBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkUrlstatusBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkUrlstatusBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("请求参数无效。请检查 `url` 参数是否提供且格式正确。");

/**
 * 当目标 URL 不可达或请求失败（如 DNS 失败、超时、连接失败）时，`status` 为 `0`。
 */
export type GetNetworkUrlstatus2 = {
  status?: number | undefined;
  url?: string | undefined;
};

export const GetNetworkUrlstatus2$zodSchema: z.ZodType<GetNetworkUrlstatus2> = z
  .object({
    status: z.int().optional(),
    url: z.string().optional(),
  }).describe(
    "当目标 URL 不可达或请求失败（如 DNS 失败、超时、连接失败）时，`status` 为 `0`。",
  );

/**
 * 当目标 URL 可访问时，`status` 为目标返回的 HTTP 状态码（如 `200`）。
 */
export type GetNetworkUrlstatus1 = {
  status?: number | undefined;
  url?: string | undefined;
};

export const GetNetworkUrlstatus1$zodSchema: z.ZodType<GetNetworkUrlstatus1> = z
  .object({
    status: z.int().optional(),
    url: z.string().optional(),
  }).describe(
    "当目标 URL 可访问时，`status` 为目标返回的 HTTP 状态码（如 `200`）。",
  );

/**
 * 检查完成！根据目标URL的可达性返回不同结果。
 */
export type GetNetworkUrlstatusResponseBody =
  | GetNetworkUrlstatus1
  | GetNetworkUrlstatus2;

export const GetNetworkUrlstatusResponseBody$zodSchema: z.ZodType<
  GetNetworkUrlstatusResponseBody
> = z.union([
  z.lazy(() => GetNetworkUrlstatus1$zodSchema),
  z.lazy(() => GetNetworkUrlstatus2$zodSchema),
]).describe("检查完成！根据目标URL的可达性返回不同结果。");

export type GetNetworkUrlstatusResponse =
  | GetNetworkUrlstatus1
  | GetNetworkUrlstatus2
  | GetNetworkUrlstatusBadRequestResponseBody
  | GetNetworkUrlstatusBadGatewayResponseBody;

export const GetNetworkUrlstatusResponse$zodSchema: z.ZodType<
  GetNetworkUrlstatusResponse
> = z.union([
  z.union([
    z.lazy(() => GetNetworkUrlstatus1$zodSchema),
    z.lazy(() => GetNetworkUrlstatus2$zodSchema),
  ]),
  z.lazy(() => GetNetworkUrlstatusBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkUrlstatusBadGatewayResponseBody$zodSchema),
]);
